import React from 'react';
import classNames from 'classnames';
import Video from '../Video';
import getImageUrl from '../../utils/getImageURL';
import * as styles from './PageBlocks.module.styl';
import CustomCTA from './CustomCTA';

export default function HeroBlock({
  title,
  byline,
  image,
  image_alt,
  video,
  customCTA,
}) {
  const content = (
    <div className={styles.heroContent}>
      <h1 className="H1">{title}</h1>
      <p style={{ color: '#888' }}>{byline}</p>
      <CustomCTA customCTA={customCTA} />
    </div>
  );

  const imgComponent = image ? (
    <img alt={image_alt} src={getImageUrl(image)} />
  ) : null;
  const videoComponent = video ? <Video video={video} /> : null;
  const media = imgComponent || videoComponent;
  return (
    <div
      className={classNames({
        [styles.ContentBlock]: 1,
        [styles.Hero]: 1,
        [styles.HeroWithMedia]: !!media,
      })}
    >
      {content}
      {media ? <div className={styles.heroMedia}>{media}</div> : null}
    </div>
  );
}
